// extracted by mini-css-extract-plugin
export default {"flex":"JU","imgwrap":"KU","image":"LU","textinfo":"MU","producttitle":"NU","bolder":"OU","block":"PU","info":"QU","moredetails":"RU","whitebox":"SU","old_price":"TU","discount":"UU"};
    if(module.hot) {
      // 1711717534549
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  